import { openConsoleTab } from '../../lib/consoleNav';

/**
 * A console settings screen — connecting a channel, AI settings, one inbox's
 * settings (the pre-flight review's "Open its settings") — opened in a
 * NEW tab from anywhere in the Communications module.
 *
 * Never in place: the screens that point at these (the campaign builder, the
 * Campaigns Guide) are usually holding work that is not saved yet, and the
 * standalone console would navigate away from it. Each offers **Check again**
 * beside the link for the moment the operator comes back. Framed by the
 * dispatch dashboard the tab goes through the signed-in handoff, because the
 * frame's session is not the console's (see openConsoleTab).
 */
export function openSettingsTab(path: '/ai' | '/connect' | `/inboxes/${number}`, embedded: boolean): void {
  if (embedded) openConsoleTab(path);
  else window.open(path, '_blank', 'noopener');
}
